import React from 'react';
import PropTypes from 'prop-types';
import Pagination from 'react-js-pagination';
import { formatUTCDate } from '../../utils/utils';

const DASH = '—';

// Date / Time and Subscription Start Date are both pre-formatted server-side
// as `dd/MM/YYYY HH:mm:ss` strings (MySQL session timezone) by the
// /admin/api/webhook-activity/list endpoint. The cell renders the API string
// verbatim — no client-side parsing or reformatting — so both timestamps on a
// row read in the same wall-clock zone and never drift between the browser
// and the server.
const fmt = (v) => (v ? formatUTCDate(String(v)) || String(v) : DASH);

const ActivityTable = ({
  rows = [],
  page = 1,
  totalPages = 0,
  totalItems = 0,
  limit = 25,
  onPageChange,
  loading = false,
}) => {
  return (
    <div className="fullwidth-table track-table-body staff-listing-admin-table-body">
      <table className="table is-striped is-fullwidth">
        <thead>
          <tr>
            <th>Date / Time</th>
            <th>Subscription Start Date</th>
            <th>Platform</th>
            <th>Event Type</th>
            <th>Status</th>
            <th>User Name</th>
            <th>User Email</th>
            <th>Order Reference</th>
          </tr>
        </thead>
        <tbody>
          {rows && rows.length > 0 ? (
            rows.map((r) => (
              <tr key={r.id}>
                <td data-label="Date / Time">{fmt(r.createdAt)}</td>
                <td data-label="Subscription Start Date">{fmt(r.subscriptionStartDate)}</td>
                <td data-label="Platform">{r.platform}</td>
                <td data-label="Event Type">{r.eventType}</td>
                <td data-label="Status">{r.derivedStatus}</td>
                <td data-label="User Name">{r.user?.name || DASH}</td>
                <td data-label="User Email">{r.user?.email || DASH}</td>
                <td data-label="Order Reference">{r.orderId || DASH}</td>
              </tr>
            ))
          ) : (
            !loading && (
              <tr>
                <td colSpan="8" style={{ textAlign: 'center', padding: '20px' }}>
                  No webhook activity in the selected range.
                </td>
              </tr>
            )
          )}
        </tbody>
      </table>
      {totalItems > limit && totalPages > 1 && (
        <Pagination
          activePage={page}
          itemsCountPerPage={limit}
          totalItemsCount={totalItems}
          pageRangeDisplayed={5}
          onChange={onPageChange}
        />
      )}
    </div>
  );
};

ActivityTable.propTypes = {
  rows: PropTypes.array,
  page: PropTypes.number,
  totalPages: PropTypes.number,
  totalItems: PropTypes.number,
  limit: PropTypes.number,
  onPageChange: PropTypes.func,
  loading: PropTypes.bool,
};

export default ActivityTable;
